import { AfterViewChecked, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { AppGlobals } from '@app/app.global';
import { AuthService, SharedService } from '@app/core';
import { DemoService } from '@modules/auth/services';

@Component({
  selector: 'app-demo-login', // The selector used to identify the component in HTML
  templateUrl: './demo-login.component.html', // The URL of the component's template file
  styleUrls: ['./demo-login.component.scss'], // The URLs of the component's style files
  host: {
    style: "display:block;", // Inline style applied to the host element
    class: "loginwrapper", // CSS class added to the host element
    "[attr.tabindex]": "-1", // Binding of the "tabindex" attribute to the value -1
  }
})

export class DemoLoginComponent implements OnInit, AfterViewChecked {
  @ViewChildren('otp') otpRefs: QueryList<ElementRef>;
  token: string;
  otp: number[] = [];
  loginForm: FormGroup;
  otpForm: FormArray;
  loginErrorMessage: string = '';
  otpErrorMessage: string = '';
  isSubmitAttempted: boolean = false;
  isOtpSubmitAttempted: boolean = false;
  private timerInterval: any;
  timeMS: number = 0;
  returnUrl: string[];

  constructor(public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public appGlobals: AppGlobals,
    public sharedService: SharedService,
    private authService: AuthService,
    private demoService: DemoService) {
    if (this.authService.isLoggedIn && this.authService.user) {
      this.router.navigate(this.appGlobals.homePath);
    }
  }

  ngOnInit(): void {
    this.createLoginForm();
    this.createOtpForm();

    this.returnUrl = this.route.snapshot.params['returnUrl'] ?
      [this.route.snapshot.params['returnUrl']] :
      this.appGlobals.homePath;
  }

  get f() { return this.loginForm.controls; }

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      mobile: ['', [Validators.required, Validators.pattern(this.appGlobals.regex.mobile)]]
    });
  }

  createOtpForm() {
    this.otpForm = this.formBuilder.array(Array(this.appGlobals.otpLength).fill('').map(
      () => this.formBuilder.control('', [Validators.required, Validators.pattern(this.appGlobals.regex.numberOnly), Validators.maxLength(1)])
    ));

    this.otpForm.controls.forEach((otp: FormControl, i) => otp.valueChanges.subscribe(value => {
      if (otp.valid && i + 1 < this.otpRefs.length) {
        this.otpRefs.get(i + 1).nativeElement.focus();
      } else if (!value && i > 0) {
        this.otpRefs.get(i - 1).nativeElement.focus();
      }
    }));
  }

  loginSubmit() {
    this.isSubmitAttempted = true;

    if (this.loginForm.invalid) {
      this.loginErrorMessage = 'Please enter valid mobile number.';
      this.isSubmitAttempted = false;
    } else {
      this.demoService.login(this.loginForm.value.mobile)
        .pipe(take(1))
        .subscribe(
          (res: any) => {
            this.token = res.token;
            this.startTimer();
          },
          (error: any) => {
            this.loginErrorMessage = error;
          },
          () => this.isSubmitAttempted = false
        );
    }
  }

  otpSubmit() {
    this.isOtpSubmitAttempted = true;

    if (this.otpForm.invalid) {
      this.otpErrorMessage = 'Please enter valid otp.';
      this.isOtpSubmitAttempted = false;
    } else {
      this.startTimer();
      this.demoService.verifyOtp(this.otpForm.value.join(''), this.token)
        .pipe(take(1))
        .subscribe(
          (res: any) => {
            this.router.navigate(this.returnUrl);
          },
          (error: any) => {
            this.otpErrorMessage = error;
          },
          () => this.isOtpSubmitAttempted = false
        );
    }
  }

  getTime() {
    return this.sharedService.humanizeSeconds(Math.floor((this.timeMS || 0) / 1000));
  }

  startTimer(): void {
    this.stopTimer();
    this.timeMS = this.appGlobals.timer * 1000;
    this.timerInterval = setInterval(() => {
      this.timeMS -= 5;

      if (this.timeMS <= 0) {
        this.stopTimer();
      }
    }, 5);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  ngAfterViewChecked(): void {
    if (this.token && this.otpForm.value?.[0] === '') {
      this.otpRefs.get(0).nativeElement.focus();
    }
  }
}